import React, { useEffect, useState } from "react";

import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";

import { fetchAccountUploadProfilePost } from "../../../services/api-raindrop.js";

import { useNavigate } from "react-router-dom";

import RaindropInputFile from "../../../ui-components/raindrop-input-file/raindrop-input-file.tsx";
import { Size } from "../../../logic/enums.ts";
import RaindropTextSubtitle from "../../../ui-components/raindrop-text-subtitle/raindrop-text-subtitle.tsx";

const RaindropAccountNewProfile = ({ userCurrent }) => {
  const navigate = useNavigate();

  const [file, setFile] = useState<File | null>(null);

  const [isDisabled, setIsDisabled] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    if (file) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [file]);

  const onSubmit = () => {
    setIsLoading(true);
    fetchAccountUploadProfilePost({
      accountId: userCurrent.account.id,
      file: file,
    })
      .then((response) => {
        navigate(`/raindrop/account/${userCurrent.account.id}`);
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div
      className={
        "flex flex-col h-full justify-center items-center gap-6 py-6 px-4"
      }
    >
      <RaindropTextSubtitle>Update Profile Picture</RaindropTextSubtitle>

      <RaindropInputFile
        label={"Upload Image"}
        onChange={(e) => setFile(e.target.files[0])}
      />

      <div className="flex flex-col w-full mt-auto">
        <RaindropButton
          isFluid={true}
          size={Size.Large}
          style={ButtonStyle.Primary}
          title="Update"
          icon="fa-plus"
          isDisabled={isDisabled}
          isLoading={isLoading}
          onClick={() => {
            onSubmit();
          }}
        />
      </div>
    </div>
  );
};

export default RaindropAccountNewProfile;
